module.exports = __webpack_public_path__ + "static/media/arrow-down-orange.16a33cf0.svg";